import { useEffect, useState } from "react";
import { Flag } from "lucide-react";
import { api } from "@/lib/api";
import { useUser } from "@/context/UserContext";
import { cn } from "@/lib/utils";

// "Flagged for you" badge — shows how many open tasks flag the current founder.
export const FlagBadge = ({ collapsed, className }) => {
  const { currentUser } = useUser();
  const [count, setCount] = useState(0);
  const isFounder = currentUser?.name === "Steven" || currentUser?.name === "Richard";

  useEffect(() => {
    if (!isFounder) return;
    let active = true;
    const load = () => api.tasksSummary().then((s) => active && setCount(s.flagged_for_me || 0)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, [isFounder]);

  if (!isFounder || count < 1) return null;
  const label = `${count} flagged for you`;

  if (collapsed) {
    return (
      <span data-testid="flag-badge-dot" title={label} aria-label={label}
        className={cn("absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#E0A82E] px-1 text-[9px] font-bold text-white ring-1 ring-[#E0A82E]/40", className)}>
        {count}
      </span>
    );
  }
  return (
    <span data-testid="flag-badge" title={label} aria-label={label}
      className={cn("inline-flex items-center gap-1 rounded-full bg-[#E0A82E]/18 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#A16207] ring-1 ring-[#E0A82E]/40", className)}>
      <Flag size={10} strokeWidth={2.6} /> {count} flagged
    </span>
  );
};
